import { ApplicationState } from '@/store';
import React, { useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import { useSelector } from 'react-redux';
import { FormDataType } from '../NewCategoryModal';
import './styles.scss';

type ShowType = (categoryForm: FormDataType) => void;
type CategoryCreatedSuccessModalType = {
    show: ShowType;
    dismiss: () => void;
};

const BaseCategoryCreatedSuccessModal: React.ForwardRefRenderFunction<CategoryCreatedSuccessModalType> = (_, ref) => {
    const [shownModal, setShownModal] = useState(false);
    const [newCategoryName, setNewCategoryName] = useState<string | undefined>(undefined);

    const timeoutRef = useRef<any>();

    const { locale } = useSelector((state: ApplicationState) => ({
        locale: state.locale.data,
    }));

    const resetName = () => setNewCategoryName(undefined);

    const show = useCallback<ShowType>(
        (categoryData: any) => {
            setNewCategoryName(categoryData[locale._LANGUAGE] || categoryData.pt);
            setShownModal(true);
        },
        [locale],
    );

    const dismiss = useCallback(() => {
        setShownModal(false);
    }, []);

    useImperativeHandle(ref, () => ({
        show,
        dismiss,
    }));

    useEffect(() => {
        if (shownModal) {
            timeoutRef.current = setTimeout(() => {
                dismiss();
            }, 3000);
        } else {
            clearTimeout(timeoutRef.current);
        }

        return () => clearTimeout(timeoutRef.current);
    }, [shownModal, dismiss]);

    return (
        <Modal backdrop centered contentClassName="category-created-success-modal-container" onExited={resetName} onHide={dismiss} show={shownModal}>
            <div className="content-container">
                <i className="material-icons-outlined align-middle success-icon" tabIndex={0}>
                    check_circle_outline
                </i>
                <span>
                    {locale.CATEGORY_MANAGEMENT_PREFIX_SUCCESS_MSG} <b>{newCategoryName}</b> {locale.CATEGORY_MANAGEMENT_SUFIX_SUCCESS_MSG}
                </span>
            </div>
        </Modal>
    );
};

export type CategoryCreatedSuccessModal = CategoryCreatedSuccessModalType;
export const CategoryCreatedSuccessModal = React.forwardRef(BaseCategoryCreatedSuccessModal);
